import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { BaseService } from '@essent/common';
import { API_PREFIX } from '@core/config-angular';
import type { Observable } from 'rxjs';
import { type SolarPanelsNewCustomerConfirmationRequestBodyV1 } from '@innogy/feh/models';

@Injectable()
export class PostSolarPanelsConfirmationService
  implements BaseService<SolarPanelsNewCustomerConfirmationRequestBodyV1, void>
{
  private readonly apiUrl: string | null = inject(API_PREFIX, {
    optional: true,
  });
  private readonly httpClient = inject(HttpClient);

  public readonly apiVersion = '1';
  public readonly endpoint = `${
    this.apiUrl ?? ''
  }/eplus/solarpanels/new-customer/confirmation/v${this.apiVersion}`;

  public call$(
    payload: SolarPanelsNewCustomerConfirmationRequestBodyV1
  ): Observable<void> {
    return this.httpClient.post<void>(this.endpoint, payload);
  }
}
